<template>
    <div class="note-timeline">
        <RocketHeaderDilaog
            width="300px"
            top="20vh"
            :visible.sync="visibleSync"
        >
            <div class="header-title">
                <span style="margin-right: 10px; font-size: 24px">版本</span>
                更新公告
            </div>
            <el-timeline class="time-line">
                <el-timeline-item
                    v-for="note in notesList"
                    :key="note.key"
                    :timestamp="note.timestamp"
                    :color="note.color"
                >
                    {{ note.content }}
                    <span @click="handleToDetail(note)" class="detail-text">
                        详情
                    </span>
                </el-timeline-item>
            </el-timeline>
            <div class="btn-line">
                <el-button
                    type="danger"
                    plain
                    class="cancelBtn"
                    @click="visibleSync = false"
                >
                    关闭
                </el-button>
            </div>
        </RocketHeaderDilaog>
        <NotesDialog ref="notesDialogRef" @know="handleKnow" />
    </div>
</template>
<script>
import DialogFooter from "@/components/layout/DialogFooter.vue";
import RocketHeaderDilaog from "@/components/layout/RocketHeaderDilaog.vue";
import NotesDialog from "./NotesDialog.vue";
import bus from "@/utils/bus";
import { apiCallback } from "@/utils";
import { getConfigNoUserId } from "@/api/common";
import { getNoticeList } from "@/api/sysMsg";
import { getUpdateNotesKnowConfig, saveUpdateNotesKnowConfig } from "./utils";
export default {
    name: "TimelineNote",
    computed: {
        userPhone() {
            return this.$store.state.user.userphone;
        },
    },
    components: {
        DialogFooter,
        RocketHeaderDilaog,
        NotesDialog,
    },
    watch: {
        userPhone: {
            handler(newVal) {
                this.checkExperience(newVal);
            },
            immediate: true,
        },
    },
    data() {
        return {
            visibleSync: false,
            notesList: [],
            dialogHeaderImg: require("@/assets/img/dialogHeader.png"),
            curUpdateNotesKnowConfig: {},
        };
    },
    methods: {
        open() {
            this.visibleSync = true;
        },
        handleToDetail({ key }) {
            this.$refs.notesDialogRef.open(key);
        },
        handleKnow(key) {
            if (!this.curUpdateNotesKnowConfig[key] || this.curUpdateNotesKnowConfig[key] === "false") {
                // 当前用户没有看过此公告，更新公告查看状态
                const cacheConfig = {
                    ...this.curUpdateNotesKnowConfig,
                    [key]: "true",
                };
                saveUpdateNotesKnowConfig(cacheConfig);
                if (key === "notes3") {
                    // 展示新手引导
                    this.$nextTick(() => {
                        bus.$emit("showUpdateNotesGuide", "notes3");
                    });
                }
                this.$store.commit(
                    "user/editUpdateNotesKnowConfig",
                    cacheConfig,
                );
            }
        },
        // 检查是否是内测用户
        checkExperience(phone) {
            return new Promise((resolve, reject) => {
                getConfigNoUserId({
                    dictKey: "web_fangcangwang_experience_users",
                }).then((res) => {
                const { dictValue } = apiCallback(res);
                const parseValue = JSON.parse(dictValue);
                isExperience = Boolean(parseValue[phone]);
                    resolve(isExperience);
                }).catch(() => {
                    resolve(false);
                });
            });
        },
        // 获取更新公告列表
        loadNoticeList() {
            return new Promise((resolve, reject) => {
                getNoticeList({
                    pageNo: 1,
                    pageSize: 50,
                    status: "T",
                    type: 16,
                }).then((res) => {
                    const { records } = apiCallback(res);
                    const cacheList = records.map((item) => ({
                        content: item.title,
                        timestamp: item.subtitle,
                        key: item.id,
                    }));
                    this.notesList = cacheList;
                    resolve(cacheList);
                });
            })
        },
        // 获取更新公告查看状态
        loadUpdateNotesKnowConfig(list) {
            let needShowNoteKey = "";
            getUpdateNotesKnowConfig().then((res) => {
                let cacheConfig = res || {};
                const isOldVersion = ['notes9', 'notes8', 'notes7', 'notes6', 'notes5', 'notes4'].some(item => { 
                    if (cacheConfig[item]) {
                        return true
                    }
                    return false
                })
                if(isOldVersion){
                    // 兼容之前版本
                    cacheConfig = list.reduce((acc, cur, index) => {
                        // 如果 res.notes9 存在，需要显示此次更新后最新的一个公告（进港舱单点击详情）
                        acc[cur.key] = index === 0 ? "false" : "true";
                        return acc;
                    }, {});
                }
                // 如果不存在 res.notes9，则表示已经是新版本
                this.curUpdateNotesKnowConfig = cacheConfig;
                this.$store.commit("user/editUpdateNotesKnowConfig", cacheConfig);
                const keyArr = list.map((item) => item.key);
                for (let i = 0; i < keyArr.length; i++) {
                    if (!cacheConfig[keyArr[i]] || cacheConfig[keyArr[i]] === "false") {
                        // 当前更新公告没有展示过
                        needShowNoteKey = keyArr[i];
                        break;
                    }
                }
                if (!needShowNoteKey) return;
                // 非内测用户不展示极速跟踪
                if(needShowNoteKey === 97){
                    this.checkExperience(this.userPhone).then(res => {
                        if(res){
                            this.$refs.notesDialogRef.open(needShowNoteKey);
                        }
                    })
                }else{
                    this.$nextTick(() => {
                        this.$refs.notesDialogRef.open(needShowNoteKey);
                    });
                }
            });
        },
        initFunc() {
            this.loadNoticeList().then((res) => {
                this.loadUpdateNotesKnowConfig(res);
            });
        }
    },
    mounted() {
        this.initFunc();
    },
};
</script>
<style lang="stylus" scoped>
.time-line{
    max-height: 50vh;
    overflow: auto;
    padding-top: 100px;
    padding-left:50px;
    user-select: none;
}

.header-title{
    text-align:center;
    font-size: 20px;
    position:absolute;
    top: -10px;
    right:20px;
    color: #fff;
    font-weight: bold;
    z-index: 9;
}
.btn-line{
    display:flex;
    justify-content:center;
    margin-top: 20px;
    width : 100%;
    padding-bottom: 20px;
}
.cancelBtn {
    color: white;
    background: linear-gradient(to right, #e5917e, #daacb9);
    border-radius: 15px;
    width:120px;
}

.detail-text{
    cursor:pointer;
    color:#c11c20;
    margin-left:10px;
}
</style>
